export const PROMOTION_DEFAULT = 'default';
export const PROMOTION_TREATMENT_DECISION_SUPPORT =
    'treatment decision support';
export const PROMOTION_SECOND_OPINION = 'second opinion';

export const SPECIALTY_ORTHOPAEDIC_SURGEON = 19;
